import { useTheme } from '@mui/material'
import { FONTS } from 'src/constants'

const GraphTickYAxis = ({ x, y, payload }: { x: number; y: number; payload: any }) => {
  const theme = useTheme()

  return (
    <text
      x={x}
      y={y}
      dx={-4}
      dy={4}
      textAnchor="middle"
      style={{
        fill: theme.palette.custom.grey2,
        fontSize: FONTS.SIZES.s,
        fontWeight: FONTS.WEIGHTS.normal,
        fontFamily: FONTS.FAMILIES.notoSans,
      }}
    >
      {payload.value}
    </text>
  )
}

export { GraphTickYAxis }
